<template>
  <div :class="'Overlay Overlay-' + mode">
    <div class="Overlay-mask"
      :style="'background:' + colour + ';' +
              'opacity:'    + opacity"></div>

    <div class="Overlay-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { inArray, ucfirst } from '@/legacy/lib//util';

  export default {
    props: {
      colour: {
        type: String,
        default: '#000'
      },

      opacity: {
        type: Number,
        default: 0.4
      },

      mode: {
        type: String,

        default: 'absolute',

        validator: function (mode) {
          return inArray (mode, [
            'absolute',
            'relative'
          ]);
        }
      }
    }
  };
</script>

<style lang="scss">
  .Overlay {
    &-absolute,
    &-mask {
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      z-index: fetch(z-index overlay);
    }

    &-relative {
      min-height: 100%;
      position: relative;
      width: 100%;
    }

    &-body {
      z-index: fetch(z-index overlay) + 1;
    }
  }
</style>